<p class="text-base">
  Discover a remarkable collection of <strong class="font-semibold">digitized Ukrainian art,</strong> each piece
  preserved in
  <strong class="font-semibold">high-resolution Digital Original format</strong> and tokenized for
  <strong class="font-semibold">authenticity and rarity. Secured on the blockchain,</strong> these artworks protect and share
  Ukraine’s cultural heritage with the world.
</p>
